export const cdnPrefix = 'https://static.fuxi.netease.com/avatar/avatarkit/agreement-20250806';

export const LoginProtocolList = [
  {
    url: `${cdnPrefix}/“绘梦天工”平台使用许可及服务协议.pdf`,
    txt: '《“绘梦天工”平台使用许可及服务协议》',
  },
  {
    url: `${cdnPrefix}/“绘梦天工”平台隐私政策.pdf`,
    txt: '《“绘梦天工”平台隐私政策》',
  },
  {
    url: `${cdnPrefix}/“绘梦天工”平台儿童个人信息保护规则及监护人须知.pdf`,
    txt: '《“绘梦天工”平台儿童个人信息保护规则及监护人须知》',
  },
  {
    url: `${cdnPrefix}/第三方服务共享清单.pdf`,
    txt: '《第三方服务共享清单》',
  },
  {
    url: `${cdnPrefix}/账号互通及双端运营特殊规则.pdf`,
    txt: '《账号互通及双端运营特殊规则》',
  },
];

export const ArtAssetProtocolList = [
  {
    url: `${cdnPrefix}/绘梦天工【资源广场】使用条款.pdf`,
    txt: '《绘梦天工【资源广场】使用条款》',
  },
];

export const AdditionalProtocolList = [
  {
    url: `${cdnPrefix}/平台模式的特殊规则.pdf`,
    txt: '《平台模式的特殊规则》',
  },
  {
    url: `${cdnPrefix}/委托模式的特殊规则.pdf`,
    txt: '《委托模式的特殊规则》',
  },
];

export const PlatformSettlementUrl = 'https://docs.popo.netease.com/lingxi/e86a00579e3840f0b2e3a3d3ab4afc28';
